/**
 * @generated SignedSource<<aaa8876396ff795718d7580931b1bd21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OtherExpenseEditRow_project$data = {
  readonly id: number;
  readonly phases: ReadonlyArray<{
    readonly color: string;
    readonly id: number;
    readonly name: string;
  }>;
  readonly " $fragmentType": "OtherExpenseEditRow_project";
};
export type OtherExpenseEditRow_project$key = {
  readonly " $data"?: OtherExpenseEditRow_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"OtherExpenseEditRow_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OtherExpenseEditRow_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "phases",
      "kind": "LinkedField",
      "name": "phases",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "projects",
  "abstractKey": null
};
})();

(node as any).hash = "9b9726664d02a9a95f80de9ddfb4642a";

export default node;
